<template>
	<div>
		<div class="max-box" :style="backgroundDiv">
			<div class="fool-btn flex_c_m">
				<van-button v-if="msginfo.voteBtn==1" type="default" class="btn-green" @click="myToupiao">我要投票</van-button>
				<van-button v-if="msginfo.enrollBtn==1" type="default" class="btn-yellow" @click="toSignUp()">我要报名</van-button>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import {
		wxTools
	} from '@utils'
	import {
		setLocal,
		getLocal
	} from '@utils/tools'
	export default {
		data() {
			return {
				voteId: '',
				voteCode:'',
				msginfo: {},
				backgroundDiv: {
					backgroundImage: '~@assets/images/img/initbg.png',
					backgroundRepeat: 'no-repeat',
				}
			}
		},
		mounted() {
			this.voteCode = this.$route.query.voteCode || this.$route.query.state;
			this.init();
			this.getUserinfo();
		},
		methods: {
			init() {
				// 获取主题详情
				this.$api.lineVote.getZhutiDetail({
					code: this.voteCode
				}, res => {
					this.msginfo = res.data;
					this.voteId = res.data.id;
					this.backgroundDiv.backgroundImage = res.data.background || '~@assets/images/img/initbg.png';
				})
			},
			getUserinfo() {
				let userInfo = !!getLocal({
					key: 'userInfo',
					parse: true
				});
				if (!userInfo) {
					console.log(11111)
					if (this.$route.query.code) {
						this.$api.user.getWxUser({
							code: this.$route.query.code
						}, res => {
							if(res.data){
								setLocal({
									key: 'userInfo',
									val: res.data
								});
							}
						})
					}
				}
			},
			
			isDuringDate(beginDateStr, endDateStr,title) {
				var curDate = new Date(),
					beginDate = beginDateStr?new Date(beginDateStr):beginDateStr,
					endDate = endDateStr?new Date(endDateStr):endDateStr;
					
				if (beginDate && curDate < beginDate) {
					this.$dialog.alert({
						title: '温馨提示',
						message: `${title}开始时间还未到！将于 `+beginDateStr+` 开始${title}！`,
					}).then(() => {
						
					});
					return false;
				}else if(endDate && curDate > endDate){
					this.$dialog.alert({
						title: '温馨提示',
						message: `${title}时间已经于`+beginDateStr+' 结束！',
					}).then(() => {
						
					});
					return false;
				}
				return true;
			},
			
			myToupiao() {
				
				if(!this.isDuringDate(this.msginfo.voteStartTime,this.msginfo.voteEndTime,'投票')) return

				new wxTools().getCode({
					securityUrl: window.location.href,
					state: this.voteCode
				});
				let userInfo = !!getLocal({
					key: 'userInfo',
					parse: true
				});
				if (userInfo) {
					this.$router.push({
						path: '/lineVote',
						query: {
							voteCode: this.voteCode
						}
					})
				}
			},
			
			toSignUp(){
				
				if(!this.isDuringDate(this.msginfo.signUpStartTime,this.msginfo.signUpEndTime,'注册')) return
				
				
				new wxTools().getCode({
					securityUrl: window.location.href,
					state: this.voteCode
				});
				let userInfo = !!getLocal({
					key: 'userInfo',
					parse: true
				});
				if (userInfo) {
					this.$router.push({
						path: '/signUp',
						query: {
							voteCode: this.voteCode
						}
					})
				}
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.max-box {
		width: 100vw;
		height: 100vh;
		background: url('~@assets/images/img/initbg.png') no-repeat;
		background-size: 100% 100%;

		.fool-btn {
			position: fixed;
			bottom: 70px;
			width: 100%;

			.btn-green {
				margin-right: 15px;
			}

			.van-button {
				width: 150px;
			}
		}
	}
</style>
